<template>
    <div class="row section">
        <div v-if="!editing" class="col">
            {{ section.section_number }}. {{ section.name }} 
            <i title="Edit" class="fas fa-pencil-alt ml-3" @click="editing = true"></i>
        </div>
        <div v-if="editing" class="col">
            {{ section.section_number }}. <input type="text" class="form-control section-name ml-2" v-model="section.name"> 
            <i title="Save" class="fas fa-save ml-3" @click="saveSectionName()"></i>
            <i title="Cancel" class="far fa-window-close ml-3" @click="editing = false"></i>
        </div>
    </div>
</template>

<style scoped>
.section {
    font-size: 1.2em;
    font-weight: bold;
}
.section-name {
    display: inline;
    width: 70%;
}
.fa-pencil-alt:hover,
.fa-save:hover,
.fa-window-close {
    cursor: pointer;
}
</style>

<script>
    export default {
        name: "Edit Section Name",

        props: ['sectionId', 'sectionNumber', 'sectionName'],

        data() {
            return {
                editing: false,
                section: {}
            }       
         },

        methods: {
            saveSectionName () {
                axios.put('/api/sections/'+ this.section.id, this.section)
                .then(function (response) {
                    this.section = response.data.data
                    location.reload()
                }.bind(this))
                .catch(function (error) {
                    console.log(error)
                })
            }
        },

        mounted () {
            this.section.id = this.sectionId
            this.section.section_number = this.sectionNumber
            this.section.name = this.sectionName
        }
    }
</script>
